import { classify } from 'sidecar-utilities'

export const inputStyles = classify({
  styles: 'opacity-0 absolute inset-0 peer',
  pointer: 'cursor-pointer disabled:cursor-not-allowed',
})

export const dropzoneStyles = ({ busy, disabled, hasTopIcon }) =>
  classify({
    hiddenInput: 'relative',
    styles: 'border-2 border-dashed rounded-lg',
    flex: 'flex gap-4 items-center',
    direction: hasTopIcon ? 'sm:flex-col' : '',
    layout: 'mb-4 last:mb-0 p-4',
    desktopPadding: hasTopIcon ? 'sm:p-6' : '',
    bgColor:
      disabled || busy
        ? 'color-bgDefaultContainer-disabled'
        : 'color-bgDefaultContainer hover:color-bgDefaultContainer-hover active:color-bgDefaultContainer-active',
    borderColor:
      disabled || busy
        ? 'color-border-disabled'
        : 'color-borderDefaultDecorStrong hover:color-borderDefaultDecorStrong-hover active:color-borderDefaultDecorStrong-active',
    pointer: disabled || busy ? 'cursor-not-allowed' : 'cursor-pointer',
  })

export const labelStyles = ({ hasTopIcon }) =>
  classify({
    group: 'group',
    alignment: 'text-left',
    desktopAlignment: hasTopIcon ? 'sm:text-center' : '',
  })

export const titleStyles = disabled =>
  classify({
    weight: 'sh-strong',
    margin: 'mb-1',
    textColor: disabled && 'color-textOnDefaultWeak',
  })

export const topIconStyles = classify({
  basic: 'shrink-0',
  visibility: 'max-sm:hidden',
})

export const iconStyles = ({ busy, hasTopIcon }) =>
  classify({
    basic: 'shrink-0',
    busy: busy && 'animate-spin',
    color: 'color-icon-default',
    visibility: hasTopIcon && 'sm:hidden',
  })

export const errorStyles = hasTopIcon =>
  classify({
    color: 'color-textRisk',
    size: 'sh-body-sm',
    desktopAlignment: hasTopIcon ? 'sm:text-center' : '',
  })
